/**
 * Delete Phase Confirmation Dialog
 *
 * Confirms deletion of a budget phase before proceeding
 * Shows phase name and warning message
 */

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface DeletePhaseDialogProps {
  /** Whether dialog is open */
  open: boolean;
  /** Phase name to display in confirmation */
  phaseName: string;
  /** Callback when delete is confirmed */
  onConfirm: () => void;
  /** Callback when delete is cancelled */
  onCancel: () => void;
  /** Whether delete operation is in progress */
  isDeleting?: boolean;
}

export function DeletePhaseDialog({
  open,
  phaseName,
  onConfirm,
  onCancel,
  isDeleting = false,
}: DeletePhaseDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <DialogContent className="bg-[#15203C] border-[#7846FF] max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="text-[#F6F6F6] text-[20px]">
            Deletar Fase de Orçamento
          </DialogTitle>
          <DialogDescription className="text-[#E7E7E7] text-[14px] pt-[12px]">
            Tem certeza que deseja deletar a fase{" "}
            <span className="font-bold text-[#F1745B]">{phaseName}</span>?
            <br />
            <br />
            Esta ação é irreversível e todos os dados dessa fase serão perdidos.
          </DialogDescription>
        </DialogHeader>
        <div className="flex gap-3 justify-end pt-4">
          <Button
            type="button"
            disabled={isDeleting}
            onClick={onCancel}
            variant="outline"
            className="border-[#7846FF] text-[#7846FF] hover:bg-[#7846FF] hover:text-white h-[50px] px-[24px] text-[16px] font-bold"
          >
            Cancelar
          </Button>
          <Button
            type="button"
            disabled={isDeleting}
            onClick={onConfirm}
            className="bg-[#F1745B] hover:bg-[#d4573e] text-white h-[50px] px-[24px] text-[16px] font-bold disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isDeleting ? "Deletando..." : "Deletar"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
